import React, { useState } from 'react';
import { useSelector } from 'react-redux';

export default function TabCreateView({
  createLeadFormComponents,
  onTabChange,
}) {
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const [activeTab, setActiveTab] = useState('0');

  const handleChange = (newValue) => {
    setActiveTab(newValue);
    if (onTabChange) {
      onTabChange(createLeadFormComponents[newValue]?.id);
    }
  };
  return (
    <div className="div-flex-column">
      <div
        className={`
    div-flex-row 
    border-bottom 
theme-horizontal-scrollable-container-${themeColor} hide-scrollbar`}
      >
        {createLeadFormComponents?.map((section, index) => (
          <div
            key={section.id}
            onClick={() => handleChange(index.toString())}
            role="button"
            data-testid={`tab-${index}`}
            tabIndex={0}
            className={
              activeTab === index.toString()
                ? `div-flex-row div-align-center cg-5 border-width-md theme-tab-active-${themeColor} py-1 px-3`
                : 'div-flex-row div-align-center cg-5 tab-common py-1 px-3'
            }
          >
            <span
              className={`
                text-sm text-nowrap text-semi-bold ${section.indicator ? 'pulse-text' : ''}`}
            >
              {section.title}
            </span>
          </div>
        ))}
      </div>
      {createLeadFormComponents?.map(
        (section, index) =>
          activeTab === index.toString() && (
            <div data-testid={`tab-panel-${index}`} key={section.id}>
              {section.component}
            </div>
          ),
      )}
    </div>
  );
}
